import { Modal } from 'ui';
import { SendInvitationsModalContent } from './send-invitations-modal-content';

type P = {
  eventId: string;
  eventInviteesCount: number;
  isOpened: boolean;
  onClose: () => void;
};

const SendInvitationsModal = ({ eventId, eventInviteesCount, isOpened, onClose }: P) => (
  <Modal
    isOpened={isOpened}
    maskProps={{
      closable: false,
    }}
    onCancel={() => {
      onClose();
    }}
    title="Send invitations"
    width="medium"
  >
    <Modal.HugContent>
      <SendInvitationsModalContent eventId={eventId} eventInviteesCount={eventInviteesCount} onClose={onClose} />
    </Modal.HugContent>
  </Modal>
);

export default SendInvitationsModal;
